(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name accounts.factory:AccountLimitOrderPeriodTypeService
     *
     * @description
     *
     */
    angular
        .module('accounts')
        .factory('AccountLimitOrderPeriodTypeService', AccountLimitOrderPeriodTypeService);

    function AccountLimitOrderPeriodTypeService($q, $http, EndpointsService, $log) {
        var AccountLimitOrderPeriodTypeServiceBase = {};
        AccountLimitOrderPeriodTypeServiceBase.getPage = function (params) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                $log.debug("AccountLimitOrderPeriodTypeServiceBase.getPage:", params);
                $http.get(response.links.accountLimitOrderPeriodType, {
                        params: params
                    })
                    .then(function (data) {
                        deferred.resolve(data.data);
                    }).catch(function (msg, code) {
                        deferred.reject(msg.data);
                    });
            }, function (error) {
                deferred.reject(error.data);
            });
            return deferred.promise;
        };
        return AccountLimitOrderPeriodTypeServiceBase;
    }
}());